import React  from 'react';
import { Avatar } from '@kineticdata/ui';
import { Moment } from '@kineticdata/react';

export const TimeAgoAndUser = ({ time, username }) => (
  <>
    <Moment timestamp={time} /> by <Avatar sm tooltip username={username} />
  </>
);
